import { render, staticRenderFns } from "./PickupSlot.vue?vue&type=template&id=b67599ec&"
import script from "./PickupSlot.vue?vue&type=script&lang=js&"
export * from "./PickupSlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports